import type { FunctionComponent } from "react";
import { PostSliderMenuPartial } from "../../../../partials/admin/menus/post/post-slider-menu.admin.partials";

export const PostSliderMenuAdminScreen: FunctionComponent = () => {
	return <PostSliderMenuPartial />;
};
